import LoadingButton from "@mui/lab/LoadingButton"
import Popover from "@mui/material/Popover"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Row from "../../../common/components/Row"

export default function GenerateEmailOrSMSCampaignPromptPopover({
  anchorElem,
  onClose,
  apiType,
}) {
  const [prompt, setPrompt] = useState("")
  const [promptError, setPromptError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const axios = useAuthorizedAxiosClient()

  const MIN_PROMPT_LEN = 30

  function handleSubmitButtonClicked() {
    setIsLoading(true)
    axios
      .get(`/workflows/api/${apiType}/generate-from-prompt/`, {
        params: { prompt },
      })
      .then(({ data }) => {
        setPrompt("")
        setPromptError(null)
        onClose(data)
      })
      .catch(() =>
        setPromptError(
          "Couldn't generate campaign from that prompt. Please try again."
        )
      )
      .finally(() => setIsLoading(false))
  }

  function handleSoftClose() {
    onClose()
  }

  return (
    <Popover
      open={!!anchorElem}
      anchorEl={anchorElem}
      onClose={handleSoftClose}
      anchorOrigin={{
        horizontal: "center",
        vertical: "center",
      }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
    >
      <Row sx={{ gap: 1, p: 1, pt: 2 }}>
        <TextField
          label="Prompt"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          error={!!promptError}
          helperText={
            promptError || `Type at least ${MIN_PROMPT_LEN} characters`
          }
          multiline
          rows={2}
          maxRows={2}
          sx={{
            width: "20em",
          }}
        />
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isLoading}
          disabled={prompt.length < MIN_PROMPT_LEN}
          sx={{ height: "63px" }}
          onClick={handleSubmitButtonClicked}
        >
          Submit
        </LoadingButton>
      </Row>
    </Popover>
  )
}
